import { Trans } from "@lingui/macro"
import { Button, ButtonSize } from "@silversea-ssc/ui-components-react"
import React, { useCallback } from "react"
import PageBanner from "../PageBanner/PageBanner"
import { useECommerceMachine, useSwitchFlowMachine } from "../../app-core/_common/machines/machines-context"
import { useIsTabletOrDesktop, VisibleMobile, VisibleTabletUp } from "../ResponsiveComponents"
import useModal from "../ModalProvider/useModal"
import { useOnCloseWebQuoteModal } from "../../app-core/v3/web-quote/WebQuoteModal/use-on-close-web-quote-modal"
import { usePreventNavigationAndRefresh } from "../../app-core/v3/payment/use-disable-back"
import { ECommerceState } from "../../app-core/v3/_common/machines/ecommerce-machine/e-commerce-machine"
import {
    isCheckout,
    isCourtesyHold,
    isWebQuote,
} from "../../app-core/v3/_common/machines/ecommerce-machine/e-commerce-machine-transitions"

type Props = {
    // keep-line
}

const NotReadyToBookBanner: React.FC<React.PropsWithChildren<Props>> = () => {
    const [state] = useECommerceMachine()
    const [, sendSF] = useSwitchFlowMachine()
    const isTabletOrDesktop = useIsTabletOrDesktop()
    const { openModal } = useModal()

    const onCloseTracked = useOnCloseWebQuoteModal(() => sendSF({ type: "SELECT_BOOKING_FLOW" }))

    const openWebQuote = useCallback(() => {
        sendSF({ type: "SELECT_WEB_QUOTE_FLOW" })
        openModal({ modalType: "web-quote-guest-info", onClose: onCloseTracked })
    }, [openModal, onCloseTracked, sendSF])
    usePreventNavigationAndRefresh(isReceiveQuoteDisabled(state))

    const buttonSize: ButtonSize = isTabletOrDesktop ? "small" : "regular"

    return (
        <PageBanner
            iconName="email"
            withBorder
            dataContentName="not_ready_to_book_banner"
            button={
                <Button
                    className="cy-open-web-quote"
                    size={buttonSize}
                    variant="inline-text"
                    onClick={openWebQuote}
                    dataContentPiece="open_web_quote_modal"
                    disabled={isReceiveQuoteDisabled(state)}
                    noWrap
                >
                    <Trans>Get your summary</Trans>
                </Button>
            }
        >
            <em>
                <Trans id="not-ready-to-book-bar-title">Not ready to book?</Trans>
            </em>
            <VisibleMobile>
                <Trans id="not-ready-to-book-bar-message-mobile">Receive your options via e-mail</Trans>
            </VisibleMobile>
            <VisibleTabletUp>
                <Trans id="not-ready-to-book-bar-message">
                    Let us send you the cruise summary so you can think about it!
                </Trans>
            </VisibleTabletUp>
        </PageBanner>
    )
}

const isReceiveQuoteDisabled = (state: ECommerceState) =>
    isCheckout(state) || isWebQuote(state) || isCourtesyHold(state)

export default NotReadyToBookBanner
